import { Pipe, PipeTransform } from '@angular/core';
import { CallSolicitationOutcomeMap } from '../models/call-solicitations.models';

@Pipe({
  name: 'callSolicitationOutcome',
})
export class CallSolicitationOutcomePipe implements PipeTransform {
  private readonly outcomeDisplayDictionary: Record<
    CallSolicitationOutcomeMap,
    string
  > = {
    [CallSolicitationOutcomeMap.Accepted]: 'Accepted',
    [CallSolicitationOutcomeMap.ExpertRejection]: 'Expert rejection',
    [CallSolicitationOutcomeMap.AdminRejection]: 'Admin rejection',
    [CallSolicitationOutcomeMap.NoAnswer]: 'No answer',
    [CallSolicitationOutcomeMap.WrongNumber]: 'Wrong number',
    [CallSolicitationOutcomeMap.CallFailed]: 'Call failed',
  };

  transform(value: CallSolicitationOutcomeMap | null | undefined): string {
    if (!value) {
      return '';
    }

    return this.outcomeDisplayDictionary[value] ?? '';
  }
}
